import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';
import * as Actions from 'actions';

class Cards extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Cards';
        this.promptMakePrimary = this.promptMakePrimary.bind(this);
        this.makeCardPrimary = this.makeCardPrimary.bind(this);
        this.cancelPrompt = this.cancelPrompt.bind(this);
        this.startEditing = this.startEditing.bind(this);
        this.promptDeleteCard = this.promptDeleteCard.bind(this);
        this.state = {
        	showConfirmation : false,
        	card : null,
        	loading : false,
        }
    }
    componentDidUpdate() {
    	console.log('cards.js updated')
    }
    promptMakePrimary(card) {
    	this.setState({showConfirmation : true, card });
    }
    makeCardPrimary() {
    	this.setState({loading : true});

		this.props.setDefaultSource(this.state.card.id, () => {
			this.setState({card:null,showConfirmation:false, loading : false});
		});
    }
    cancelPrompt() {
    	this.setState({loading:false, showConfirmation: false, card : null});
    }
    startEditing(card) {
    	this.props.showEditCard();
    	this.props.updateCard(card);
    }
    promptDeleteCard(card) {
    	this.props.showDeleteCard();
    	this.props.updateCard(card);
    }
    render() {
    	var cards = [];
    	var customer = this.props.account.customer;
    	if(this.props.cards) {
    		cards = this.props.cards;
    	}
    	if(this.props.account)
	        return (
	        	<div>
		        	<div className="list-group">
                {cards.length == 0 ? (
                  <p className="alert alert-info">You don't have a card set up. <a onClick={e => {
                    e.preventDefault();
                    this.props.showAddCard();
                  }} href="#"><span className="fa fa-plus"></span> Add One</a>.</p>
                ) : ''}
		        		{cards.map((card)=>{
		        			// console.log("CardID: " + card.id + " Default Source: " + customer.default_source);
		        			var primary = card.id == customer.default_source ? true : false;
		        			var button = "";
		        			var className = "";

		        			if(!primary)
		        			button = <div className="col-xs-12 col-sm-6 col-md-4">
		        						<div onClick={() => this.promptMakePrimary(card)} className="btn btn-block btn-info mb-sm">Make Primary</div>
		        						<div className="pull-right btn-group" id="credit-cards-button-group">
			        						<div onClick={()=> this.promptDeleteCard(card)} className="btn btn-danger"><i className="fa fa-trash"></i></div>
			        						<div onClick={() => this.startEditing(card)} className="btn btn-warning"><i className="fa fa-edit"></i></div>
		        						</div>
			        				</div>;
			        		else {
			        		button = <div className="col-xs-12 col-sm-6 col-md-4">
		        						<div className="pull-right btn-group" id="credit-cards-button-group">
			        						<div onClick={()=> this.promptDeleteCard(card)} className="btn btn-danger"><i className="fa fa-trash"></i></div>
			        						<div onClick={() => this.startEditing(card)} className="btn btn-warning"><i className="fa fa-edit"></i></div>
		        						</div>
			        				</div>;
			        			className = "list-group-item-info";
			        		}

		        			return (
		        				<div className={"list-group-item clearfix " + className} >
			        				<div className="row">
				        				<div className="col-xs-12 col-sm-6 col-md-8"><h5><i className="fa fa-user"></i> {card.name}</h5><h5><i className="fa fa-credit-card"></i> {card.brand} - Ending in {card.last4}</h5></div>
				       					{button}
				       				</div>
			        			</div>

		        				);
		        		})}
		            </div>
		            {(()=>{
		            	if(this.state.card)
		            		return(
					            <Modal show={this.state.showConfirmation} onHide={this.cancelPrompt}>
					            	<div className="panel panel-primary mb-none">
					            		<div className="panel-heading">
					            			<h3 className="panel-title">{this.state.card.brand} - {this.state.card.last4}</h3>
					            		</div>
					            		<div className="panel-body">
					            			<p>Make card ending in {this.state.card.last4} your primary payment method?</p>
					            		</div>
					            		<div className="panel-footer">
					            			<div className="row">
					            				<div className="col-xs-12 col-md-4 col-md-offset-4">
							            			<div onClick={this.cancelPrompt} className="btn btn-block btn-default">Cancel</div>
						            			</div>
					            				<div className="col-xs-12 col-md-4">
							            			<div onClick={this.makeCardPrimary} className="btn btn-block btn-primary">Yes</div>
							            		</div>
					            			</div>
					            		</div>
					            	</div>
					            </Modal>
		            		)
		            })()}

		        </div>
	        );
	    else
	    	return <div></div>;
    }
}

var mapStateToProps = ({account}) => {
	var cards = [];
	if(account.customer) {
		cards = account.customer.sources.data;
	}
	return { cards, account };
}

export default connect(mapStateToProps, Actions)(Cards);



// WEBPACK FOOTER //
// ./src/browser/components/account/cards.js